import { render, staticRenderFns } from "./VersionImportDataGrid.vue?vue&type=template&id=830c4b50&scoped=true&"
import script from "./VersionImportDataGrid.vue?vue&type=script&lang=js&"
export * from "./VersionImportDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./VersionImportDataGrid.vue?vue&type=style&index=0&id=830c4b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830c4b50",
  null
  
)

export default component.exports